import React, { useEffect } from "react";
import { PreviewProvider, usePreview } from "../../editor/context/PreviewContext";
import "../../editor/device-frames.css";

const StageInner = ({ children, modeProp }) => {
  const { mode, setMode, viewport, frameKind, showFrame, manualZoom } = usePreview();

  useEffect(() => {
    if (modeProp && modeProp !== mode) {
      try { setMode(modeProp); } catch (_) {}
    }
  }, [modeProp, mode, setMode]);

  if (mode === "responsive" || !viewport) {
    // In responsive mode, pretend we are very wide so desktop-like UI paths render
    return <div className="h-full overflow-y-auto">{children({ containerWidth: 1440 })}</div>;
  }

  return (
    <div className={`device-stage ${frameKind === "phone" ? "stage-phone" : ""}`} style={{ overflow: "auto" }}>
      <div className={`device-frame ${showFrame ? frameKind : ""}`} style={{ transform: `scale(${manualZoom})`, willChange: "transform" }}>
        <div className="device-viewport" style={{ width: viewport.width, height: viewport.height }}>
          <div className="device-viewport-scroll">
            {children({ containerWidth: viewport.width })}
          </div>
        </div>
        {showFrame && frameKind === "desktop" && <div className="desktop-stand" />}
      </div>
    </div>
  );
};

const PreviewDeviceStage = ({ children, mode, contextOverrides }) => {
  return (
    <PreviewProvider valueOverrides={contextOverrides}>
      <StageInner modeProp={mode}>{children}</StageInner>
    </PreviewProvider>
  );
};

export default PreviewDeviceStage;


